import { render } from "./PublicSearchResultPage.vue?vue&type=template&id=17887432&scoped=true&ts=true"
import script from "./PublicSearchResultPage.vue?vue&type=script&lang=ts"
export * from "./PublicSearchResultPage.vue?vue&type=script&lang=ts"

import "./PublicSearchResultPage.vue?vue&type=style&index=0&id=17887432&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src536781470/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17887432"]])

export default __exports__